import mutations from './mutations';
import actions from './actions';

const state = {
    host: '',
    blinkCardSubject: {
        subjectId: 0,
        subjectName: '',
        subjectInfo: {},
        cardList: [],
        activityInfo: {},
        ownedCardCount: 0,
        totalCardCount: 0,
        curIndex: 0,
        cardBackImgUrl: '',
        subjectLogoImgUrl: '',
    },
};

export default {
    state,
    mutations,
    actions,
};
